//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
/** Components Import */
import {
  Stack,
  Box,
  Typography,
  Badge,
  IconButton,
  TextField,
  Tabs,
  Tab,
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableCell,
  createTheme,
  ThemeProvider,
  CssBaseline,
  Button as MuiButton,
} from '@mui/material';
/** Icons Import */
import { Check as CheckIcon, Close as CloseIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { Button, Combo, Dialog, Radio, Checkbox } from '../../Components/MUIs';
import Canvas from '../../Components/Canvas/Canvas';
import { KakaoPost } from '../../Components/Kakaos';

import Commons from '../../Services/Common/Common';
import { FileForm } from '../../Components/FileForm/index';
import avata from '../../Assets/Images/avata_160x160.png';
import vector from '../../Assets/Images/Vector.png';
import safeonJourneyman1 from '../../Assets/Images/safeOn_journeyman1.png';
import safeonJourneyman2 from '../../Assets/Images/safeOn_journeyman2.png';
//#endregion

// const theme = createTheme({
//   typography: {
//     htmlFontSize: Commons.IsMobile() ? 6 : 10,
//     fontFamily: "Pretendard, sans-serif",
//   },
//   palette: {
//     // mode: "dark",
//     // background: {
//     // 	default: "#090e23",
//     // 	paper: "#090e23",
//     // },
//     primary: {
//       light: "#008b43",
//       main: "#008b43",
//       dark: "#00b557",
//       contrastText: "#fff",
//     },
//     // secondary: {
//     // 	light: "#ff7961",
//     // 	main: "#f44336",
//     // 	dark: "#ba000d",
//     // 	contrastText: "#000",
//     // },
//   },
//   button: {
//     backgroundColor: "#F3F7F8",
//     color: "#000",
//     fontSize: "28px",
//     width: "180px",
//     height: "60px",
//     borderRadius: "16px",
//   },
// });

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    // <ThemeProvider theme={theme}>
    // <CssBaseline />
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ width: '100%' }}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {/* <Typography>{children}</Typography> */}
          {children}
        </Box>
      )}
    </div>
    // </ThemeProvider>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

function MyPage(props) {
  //#region 변수
  const [value, setValue] = React.useState(0);
  const [kakaoPost, setKakaoPost] = useState(false); // 카카오 지도
  const signatureCanvas = useRef(); // 서명 REF
  //#endregion
  //#region 데이터
  //#endregion
  //#region 나머지 함수
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const GetPostData = (_data) => {
    props.setInputs2({
      ...props.inputs2,
      post: _data.road_address.zone_no,
      address1: _data.road_address.address_name,
    });
  };
  //#endregion

  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: 'background.paper',
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        height: '100%',
        // mt: 12,
      }}
    >
      <Stack direction="row" sx={{ width: '60%' }}>
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{
            borderRight: 1,
            borderColor: 'divider',
            width: '200px',
          }}
        >
          <Tab
            label={
              props.lanInfo.length > 0
                ? props.lanInfo.filter(
                    (f) => f.LAN_ID === 'EditPersonalInfo'
                  )[0].LAN_NM // 개인정보 수정
                : ''
            }
            sx={{ fontSize: '0.95rem', fontWeight: 'bold', color: '#000' }}
            {...a11yProps(0)}
          />
          <Tab
            label={
              props.lanInfo.length > 0
                ? props.lanInfo.filter((f) => f.LAN_ID === 'ChangePassword')[0]
                    .LAN_NM // 비밀번호 변경
                : ''
            }
            sx={{ fontSize: '0.95rem', fontWeight: 'bold', color: '#000' }}
            {...a11yProps(1)}
          />
        </Tabs>
        <TabPanel value={value} index={0}>
          {props.confirm ? (
            <React.Fragment>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }}>
                  <colgroup>
                    <col style={{ width: '160px' }} />
                    <col style={{ width: '160px' }} />
                    <col style={{ width: '400px' }} />
                    <col style={{ width: '160px' }} />
                    <col style={{ width: '200px' }} />
                    <col style={{ width: '200px' }} />
                  </colgroup>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'아이디'}
                      </TableCell>
                      <TableCell
                        align="center"
                        colSpan={4}
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          p: '8px',
                        }}
                      >
                        <TextField
                          fullWidth
                          value={props.inputs2.id ? props.inputs2.id : ''}
                          // onChange={(e) => {
                          //   const newValue = e.target.value;
                          //   props.setInputs2((prevState) => ({
                          //     ...prevState,
                          //     id: newValue,
                          //   }));
                          // }}
                          onChange={(e) => {
                            props.setInputs2({
                              ...props.inputs2,
                              id: e.target.value,
                            });
                          }}
                          sx={{
                            '& .MuiInputBase-input': {
                              fontSize: '12px',
                            },
                          }}
                          size="small"
                          disabled
                        />
                      </TableCell>
                      <TableCell align="center" rowSpan={4} sx={{ p: '8px' }}>
                        <Badge
                          overlap="circular"
                          anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                          }}
                          badgeContent={
                            <IconButton
                              onClick={() => {
                                props.DeleteLogic2();
                              }}
                            >
                              <CloseIcon />
                            </IconButton>
                          }
                        >
                          <Box
                            sx={{
                              width: '100%',
                              height: '160px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              overflow: 'hidden',
                              border: '1px solid red',
                            }}
                          >
                            {props.imageFile.profileFiles ? (
                              <img
                                id={'fileId'}
                                src={props.imageFile.profileFiles || ''}
                                style={{
                                  maxWidth: '100%',
                                  objectFit: 'contain',
                                }}
                              />
                            ) : (
                              <img
                                id={'fileId'}
                                src={avata}
                                style={{
                                  maxWidth: '100%',
                                  objectFit: 'contain',
                                }}
                              />
                            )}
                          </Box>
                        </Badge>
                        <Button
                          component="label"
                          role={undefined}
                          variant="contained"
                          tabIndex={-1}
                          sx={{
                            color: '#fff',
                            backgroundColor: '#2CA900',
                            fontSize: '12px',
                            width: '120px',
                            borderRadius: '8px',
                            mt: '8px',
                          }}
                          name={
                            <>
                              {props.lanInfo.length > 0
                                ? props.lanInfo.filter(
                                    (f) => f.LAN_ID === 'Modity'
                                  )[0].LAN_NM // 수정
                                : ''}
                              <VisuallyHiddenInput
                                type="file"
                                accept="image/*"
                                onChange={(event) => {
                                  const fileList = event.target.files;
                                  if (Object.keys(fileList).length === 0)
                                    return;

                                  const file = fileList[0]; // single file upload

                                  const reader = new FileReader();
                                  reader.readAsDataURL(file);
                                  reader.onload = (e) => {
                                    fetch(e.target.result)
                                      .then((res) => res.blob())
                                      .then((blob) => {
                                        const image = new File(
                                          [blob],
                                          `${new Date()
                                            .toISOString()
                                            .replace(/T/, '')
                                            .replace(/\..+/, '')
                                            .replace(/-/g, '')
                                            .replace(/:/g, '')}.png`,
                                          {
                                            type: '/png',
                                          }
                                        );

                                        props.setImageFile({
                                          ...props.imageFile,
                                          profileFiles: reader.result,
                                          profileImage: image,
                                          profileFileName: file.name,
                                        });

                                        // 사진경로 업데이트트
                                        if (props.imageFile.type === 'Unit') {
                                        } else {
                                        }
                                      });
                                  };
                                  reader.onerror = (error) => {
                                    console.log(error);
                                    // 파일 읽기 중 에러가 발생했을 때 실행될 코드
                                  };
                                }}
                              />
                            </>
                          }
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          p: '8px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'생년월일'}
                      </TableCell>
                      <TableCell
                        align="center"
                        colSpan={4}
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          p: '8px',
                        }}
                      >
                        <TextField
                          fullWidth
                          value={
                            props.inputs2.birth
                              ? props.inputs2.birth.slice(0, 4) +
                                '-' +
                                props.inputs2.birth.slice(4, 6) +
                                '-' +
                                props.inputs2.birth.slice(6)
                              : ''
                          }
                          onChange={(e) => {
                            props.setInputs2({
                              ...props.inputs2,
                              birth: e.target.value,
                            });
                          }}
                          sx={{
                            '& .MuiInputBase-input': {
                              fontSize: '12px',
                            },
                          }}
                          size="small"
                          disabled
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          p: '8px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'국적'}
                      </TableCell>
                      <TableCell
                        align="center"
                        colSpan={4}
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          p: '8px',
                        }}
                      >
                        <Combo
                          fullWidth
                          items={props.nationList}
                          value={props.inputs2.nation}
                          onChange={(e) => {
                            props.setInputs2({
                              ...props.inputs2,
                              nation: e,
                            });
                          }}
                          sx={{
                            textAlign: 'start',
                            fontSize: '12px',
                          }}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          p: '8px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'혈액형'}
                      </TableCell>
                      <TableCell
                        align="center"
                        colSpan={4}
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          p: '8px',
                        }}
                      >
                        <Combo
                          fullWidth
                          items={props.bloodList}
                          value={props.inputs2.blood}
                          onChange={(e) => {
                            props.setInputs2({
                              ...props.inputs2,
                              blood: e,
                            });
                          }}
                          sx={{
                            textAlign: 'start',
                            fontSize: '12px',
                          }}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          p: '8px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'이름'}
                      </TableCell>
                      <TableCell align="center" colSpan={5} sx={{ p: '8px' }}>
                        <TextField
                          fullWidth
                          value={props.inputs2.name ? props.inputs2.name : ''}
                          onChange={(e) => {
                            props.setInputs2({
                              ...props.inputs2,
                              name: e.target.value,
                            });
                          }}
                          sx={{
                            '& .MuiInputBase-input': {
                              fontSize: '12px',
                            },
                          }}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          p: '8px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'이메일'}
                      </TableCell>
                      <TableCell align="center" colSpan={5} sx={{ p: '8px' }}>
                        <TextField
                          fullWidth
                          value={props.inputs2.email ? props.inputs2.email : ''}
                          onChange={(e) => {
                            props.setInputs2({
                              ...props.inputs2,
                              email: e.target.value,
                            });
                          }}
                          sx={{
                            '& .MuiInputBase-input': {
                              fontSize: '12px',
                            },
                          }}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          p: '8px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'전화번호'}
                      </TableCell>
                      <TableCell align="center" colSpan={5} sx={{ p: '8px' }}>
                        <TextField
                          fullWidth
                          value={props.inputs2.tel ? props.inputs2.tel : ''}
                          type="tel"
                          inputProps={{
                            maxLength: 13,
                          }}
                          onChange={(e) => {
                            props.setInputs2({
                              ...props.inputs2,
                              tel: e.target.value
                                .replace(/[^0-9]/g, '')
                                .replace(
                                  /^(\d{0,3})(\d{0,4})(\d{0,4})$/g,
                                  '$1-$2-$3'
                                )
                                .replace(/(\-{1,2})$/g, ''),
                            });
                          }}
                          sx={{
                            '& .MuiInputBase-input': {
                              fontSize: '12px',
                            },
                          }}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          p: '8px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'비상연락처'}
                      </TableCell>
                      <TableCell align="center" colSpan={5} sx={{ p: '8px' }}>
                        <TextField
                          fullWidth
                          value={props.inputs2.emtel ? props.inputs2.emtel : ''}
                          type="tel"
                          inputProps={{
                            maxLength: 13,
                          }}
                          onChange={(e) => {
                            props.setInputs2({
                              ...props.inputs2,
                              emtel: e.target.value
                                .replace(/[^0-9]/g, '')
                                .replace(
                                  /^(\d{0,3})(\d{0,4})(\d{0,4})$/g,
                                  '$1-$2-$3'
                                )
                                .replace(/(\-{1,2})$/g, ''),
                            });
                          }}
                          sx={{
                            '& .MuiInputBase-input': {
                              fontSize: '12px',
                            },
                          }}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="center"
                        rowSpan={3}
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          p: '8px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'주소'}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          p: '8px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'우편번호'}
                      </TableCell>
                      <TableCell align="center" colSpan={5} sx={{ p: '8px' }}>
                        <Stack direction="row">
                          <TextField
                            fullWidth
                            value={props.inputs2.post ? props.inputs2.post : ''}
                            onChange={(e) => {
                              props.setInputs2({
                                ...props.inputs2,
                                post: e.target.value,
                              });
                            }}
                            sx={{
                              '& .MuiInputBase-input': {
                                fontSize: '12px',
                              },
                            }}
                            size="small"
                            disabled
                          />
                          <Button
                            sx={{
                              color: '#fff',
                              backgroundColor: '#2CA900',
                              fontSize: '12px',
                              width: '120px',
                              borderRadius: '8px',
                              ml: '8px',
                            }}
                            name={
                              props.lanInfo.length > 0
                                ? props.lanInfo.filter(
                                    (f) => f.LAN_ID === 'SearchAddress'
                                  )[0].LAN_NM // 주소 검색
                                : ''
                            }
                            onClick={() => setKakaoPost(true)}
                          />
                        </Stack>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          p: '8px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'주소'}
                      </TableCell>
                      <TableCell align="center" colSpan={5} sx={{ p: '8px' }}>
                        <TextField
                          fullWidth
                          value={
                            props.inputs2.address1 ? props.inputs2.address1 : ''
                          }
                          onChange={(e) => {
                            props.setInputs2({
                              ...props.inputs2,
                              address1: e.target.value,
                            });
                          }}
                          sx={{
                            '& .MuiInputBase-input': {
                              fontSize: '12px',
                            },
                          }}
                          size="small"
                          disabled
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          p: '8px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'나머지주소'}
                      </TableCell>
                      <TableCell align="center" colSpan={5} sx={{ p: '8px' }}>
                        <TextField
                          fullWidth
                          value={
                            props.inputs2.address2 ? props.inputs2.address2 : ''
                          }
                          onChange={(e) => {
                            props.setInputs2({
                              ...props.inputs2,
                              address2: e.target.value,
                            });
                          }}
                          sx={{
                            '& .MuiInputBase-input': {
                              fontSize: '12px',
                            },
                          }}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          p: '8px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'경력'}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          p: '8px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'경력유무'}
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          p: '8px',
                        }}
                      >
                        <Radio
                          nameSx={{
                            '& .MuiSvgIcon-root': {
                              fontSize: '12px',
                            }, // 체크박스 아이콘 크기 설정
                            '& .MuiFormControlLabel-label': {
                              fontSize: '16px', // 레이블 글자 크기 설정
                            },
                          }}
                          row={true}
                          value={
                            props.inputs2.careerYn
                              ? props.inputs2.careerYn
                              : 'N'
                          }
                          onChange={(e) => {
                            if (e === 'Y') {
                              props.setInputs2({
                                ...props.inputs2,
                                careerYn: e,
                              });
                            } else {
                              props.setInputs2({
                                ...props.inputs2,
                                careerYn: e,
                                careerPeriod: null,
                              });
                            }
                          }}
                          items={[
                            {
                              name: '예',
                              value: 'Y',
                              sx: {
                                '&.Mui-checked': {
                                  color: '#2CA900', // 체크됐을 때 색깔
                                },
                                color: '#D2E1E5',
                              },
                              labelSx: {
                                fontSize: '12px',
                                '& .MuiTypography-root': { fontSize: '12px' },
                              },
                            },
                            {
                              name: '아니오',
                              value: 'N',
                              sx: {
                                '&.Mui-checked': {
                                  color: '#2CA900', // 체크됐을 때 색깔
                                },
                                color: '#D2E1E5',
                              },
                              labelSx: {
                                fontSize: '12px',
                                '& .MuiTypography-root': { fontSize: '12px' },
                              },
                            },
                          ]}
                        />
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          p: '8px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'경력기간'}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: '400px',
                          p: '8px',
                        }}
                        colSpan={2}
                      >
                        <Combo
                          fullWidth
                          items={props.careerPeriodList}
                          value={
                            props.inputs2.careerYn === 'N'
                              ? ''
                              : props.inputs2.careerPeriod
                          }
                          onChange={(e) => {
                            props.setInputs2({
                              ...props.inputs2,
                              careerPeriod: e,
                            });
                          }}
                          sx={{
                            textAlign: 'start',
                            fontSize: '12px',
                          }}
                          size="small"
                          disabled={
                            props.inputs2.careerYn === 'N' ? true : false
                          }
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          p: '8px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'보건카드'}
                      </TableCell>
                      <TableCell align="left" colSpan={5} sx={{ p: '8px' }}>
                        <Button
                          sx={{
                            color: '#fff',
                            backgroundColor: '#2CA900',
                            fontSize: '12px',
                            width: '120px',
                            borderRadius: '8px',
                          }}
                          name={
                            props.lanInfo.length > 0
                              ? props.lanInfo.filter(
                                  (f) => f.LAN_ID === 'Look'
                                )[0].LAN_NM // 보기
                              : ''
                          }
                          onClick={() => {
                            props.SearchLogic2(
                              props.inputs2.healthImage,
                              'health'
                            );
                            props.setModalToggle(true);
                          }}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          p: '8px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'비자'}
                      </TableCell>
                      <TableCell align="center" colSpan={5} sx={{ p: '8px' }}>
                        <TextField
                          fullWidth
                          value={props.inputs2.visa ? props.inputs2.visa : ''}
                          onChange={(e) => {
                            props.setInputs2({
                              ...props.inputs2,
                              visa: e.target.value,
                            });
                          }}
                          sx={{
                            '& .MuiInputBase-input': {
                              fontSize: '12px',
                            },
                          }}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: 1,
                          borderColor: 'divider',
                          fontSize: '12px',
                          p: '8px',
                          backgroundColor: '#F3F7F8',
                        }}
                      >
                        {'서명'}
                      </TableCell>
                      <TableCell align="left" colSpan={5} sx={{ p: '8px' }}>
                        <Button
                          sx={{
                            color: '#fff',
                            backgroundColor: '#2CA900',
                            fontSize: '12px',
                            width: '120px',
                            borderRadius: '8px',
                          }}
                          name={
                            props.lanInfo.length > 0
                              ? props.lanInfo.filter(
                                  (f) => f.LAN_ID === 'Look'
                                )[0].LAN_NM // 보기
                              : ''
                          }
                          onClick={() => {
                            props.SearchLogic2(props.inputs2.sign, 'sign');
                            props.setModalToggle2(true);
                          }}
                        />
                      </TableCell>
                    </TableRow>
                    {(props.userInfo.authCd === 'HEAD_MANAGER' ||
                      props.userInfo.authCd === 'BUSINESS_OWNER' ||
                      props.userInfo.authCd === 'ADMIN') && (
                      <TableRow>
                        <TableCell
                          align="center"
                          sx={{
                            borderRight: 1,
                            borderColor: 'divider',
                            fontSize: '12px',
                            p: '8px',
                            backgroundColor: '#F3F7F8',
                          }}
                        >
                          {'직인'}
                        </TableCell>
                        <TableCell align="left" colSpan={5} sx={{ p: '8px' }}>
                          <Button
                            sx={{
                              color: '#fff',
                              backgroundColor: '#2CA900',
                              fontSize: '12px',
                              width: '120px',
                              borderRadius: '8px',
                            }}
                            name={
                              props.lanInfo.length > 0
                                ? props.lanInfo.filter(
                                    (f) => f.LAN_ID === 'Look'
                                  )[0].LAN_NM // 보기
                                : ''
                            }
                            onClick={() => {
                              props.SearchLogic2(
                                props.inputs2.journeyman,
                                'journeyman'
                              );
                              props.setModalToggle5(true);
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box
                sx={{
                  display: 'flex',
                }}
              >
                <Button
                  sx={{
                    color: 'rgba(0,0,0,0.5)',
                    fontSize: '12px',
                    mt: 2,
                  }}
                  variant="text"
                  name={'회원탈퇴 >'}
                  onClick={() => {
                    props.setModalToggle4(true);
                  }}
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignContent: 'center',
                  justifyContent: 'center',
                  mt: 2,
                }}
              >
                <Button
                  sx={{
                    color: '#fff',
                    backgroundColor: '#2CA900',
                    fontSize: '28px',
                    width: '240px',
                    height: '60px',
                    borderRadius: '16px',
                    // ...btnSx,
                  }}
                  name={
                    props.lanInfo.length > 0
                      ? props.lanInfo.filter((f) => f.LAN_ID === 'Save')[0]
                          .LAN_NM // 저장
                      : ''
                  }
                  onClick={() => props.SaveLogic1()}
                />
              </Box>
              <KakaoPost
                open={kakaoPost}
                onClose={() => setKakaoPost(false)}
                maxWidth="md"
                title={
                  props.lanInfo.length > 0
                    ? props.lanInfo.filter(
                        (f) => f.LAN_ID === 'SearchAddress'
                      )[0].LAN_NM // 주소 검색
                    : ''
                }
                ReceivePost={(_data) => GetPostData(_data)}
              />
            </React.Fragment>
          ) : (
            <Box>
              <Stack
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  p: 2,
                }}
                spacing={2}
              >
                <Typography variant="h4">
                  {props.lanInfo.length > 0
                    ? props.lanInfo.filter(
                        (f) => f.LAN_ID === 'PleaseEnterYourPassword'
                      )[0].LAN_NM // 비밀번호를 입력하세요.
                    : ''}
                </Typography>
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                  }}
                >
                  <TextField
                    type="password"
                    label=""
                    sx={{
                      width: '200px',
                      '& .MuiInputBase-input': {
                        fontSize: '16px',
                      },
                    }}
                    value={props.certificationInputs.passwoard}
                    onChange={(e) => {
                      props.setCertificationInputs({
                        ...props.certificationInputs,
                        passwoard: e.target.value,
                      });
                    }}
                    onKeyDown={(e) => e.key === 'Enter' && props.SearchLogic1()}
                    autoFocus
                  />
                  <Button
                    sx={{
                      fontSize: '28px',
                      width: '180px',
                      height: '60px',
                      color: '#fff',
                      backgroundColor: '#2CA900',
                      borderRadius: '16px',
                    }}
                    name={
                      props.lanInfo.length > 0
                        ? props.lanInfo.filter((f) => f.LAN_ID === 'Confirm')[0]
                            .LAN_NM // 확인
                        : ''
                    }
                    onClick={() => props.SearchLogic1()}
                  />
                </Stack>
              </Stack>
            </Box>
          )}
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Box sx={{ p: 1 }}>
            <Stack spacing={2}>
              <TextField
                label={
                  props.lanInfo.length > 0
                    ? props.lanInfo.filter(
                        (f) => f.LAN_ID === 'CurrentPassword'
                      )[0].LAN_NM // 현재 비밀번호
                    : ''
                }
                value={
                  props.inputs.currentPassword
                    ? props.inputs.currentPassword
                    : ''
                }
                onChange={(e) => {
                  props.setInputs({
                    ...props.inputs,
                    currentPassword: e.target.value,
                  });
                }}
                onKeyUp={(e) => props.checkCapsLock(e)}
                type="password"
              />
              <TextField
                fullWidth
                label={
                  props.lanInfo.length > 0
                    ? props.lanInfo.filter((f) => f.LAN_ID === 'Password')[0]
                        .LAN_NM // 비밀번호
                    : ''
                }
                value={props.inputs.password ? props.inputs.password : ''}
                onChange={(e) => {
                  props.setInputs({
                    ...props.inputs,
                    password: e.target.value,
                  });
                }}
                onKeyUp={(e) => props.checkCapsLock(e)}
                type="password"
              />
              <TextField
                fullWidth
                label={
                  props.lanInfo.length > 0
                    ? props.lanInfo.filter(
                        (f) => f.LAN_ID === 'PasswordConfirm'
                      )[0].LAN_NM // 비밀번호 확인
                    : ''
                }
                value={
                  props.inputs.passwordConfirm
                    ? props.inputs.passwordConfirm
                    : ''
                }
                onChange={(e) => {
                  props.setInputs({
                    ...props.inputs,
                    passwordConfirm: e.target.value,
                  });
                }}
                onKeyUp={(e) => props.checkCapsLock(e)}
                type="password"
              />
              {props.capsLockFlag && (
                <Typography variant="caption" color="red">
                  {`Caps Lock이 켜져 있습니다`}
                </Typography>
              )}
              <Typography variant="caption">
                {`(8자리 이상, 대문자, 숫자, 특수문자(!@#$%^&*)가 포함되어야합니다.)`}
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginY: 1.5,
                  marginX: 1,
                }}
              >
                <Button
                  sx={{
                    backgroundColor: '#F3F7F8',
                    color: '#000',
                    fontSize: '28px',
                    width: '100%',
                    height: '60px',
                    borderRadius: '16px',
                    mr: 2,
                  }}
                  size="medium"
                  name={
                    props.lanInfo.length == 0
                      ? ''
                      : props.lanInfo.find(
                          (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'Cancle'
                        ).LAN_NM //취소
                  }
                  onClick={() => {
                    props.setInputs({
                      ...props.inputs,
                      currentPassword: '',
                      password: '',
                      passwordConfirm: '',
                    });
                  }}
                ></Button>
                <Button
                  sx={{
                    color: '#fff',
                    backgroundColor: '#2CA900',
                    fontSize: '28px',
                    width: '100%',
                    height: '60px',
                    borderRadius: '16px',
                  }}
                  size="medium"
                  name={
                    props.lanInfo.length == 0
                      ? ''
                      : props.lanInfo.find(
                          (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'Save'
                        ).LAN_NM //저장
                  }
                  onClick={() => {
                    props.SaveLogic2();
                    props.setInputs({
                      ...props.inputs,
                      currentPassword: '',
                      password: '',
                      passwordConfirm: '',
                    });
                  }}
                ></Button>
              </Box>
            </Stack>
          </Box>
        </TabPanel>
      </Stack>
      {/* 보건카드 팝업 창 */}
      {props.modalToggle && (
        <Dialog
          title={
            props.lanInfo.length == 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'ImageSetup'
                ).LAN_NM
          } //사진 설정
          titleSx={{ fontSize: '24px' }}
          open={props.modalToggle}
          onClose={(e) => {
            props.setImageFile({
              ...props.imageFile,
              healthFiles: '',
              healthImage: '',
            });
            props.setModalToggle(false);
          }}
          contentSx={{
            display: 'flex',
            flexDirection: 'column',
            height: '40vh',
          }}
          fullWidth
          saveButtonName={
            props.lanInfo.length == 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'Save'
                ).LAN_NM
          } //선택
          closeButtonName={
            props.lanInfo.length == 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'Close'
                ).LAN_NM
          } //닫기
          useSaveButton={true}
          useSaveAfterClose={false}
          onSave={() => {
            props.SaveLogic3();
            if (props.imageFile.healthImage) {
              props.setImageFile({
                ...props.imageFile,
                healthFiles: '',
                healthImage: '',
              });
              props.setModalToggle(false);
            }
          }}
          maxWidth="sm"
          btnSx={{ width: '120px', height: '60px' }}
          content={
            <div
              className="ag-theme-alpine no-scroll"
              style={{
                width: '100%',
                height: '100%',
                alignContent: 'center',
              }}
            >
              <FileForm
                datas={[
                  {
                    type: 'file',
                    sx: { fontSize: 14 },
                    name:
                      props.lanInfo.length == 0
                        ? ''
                        : props.lanInfo.find(
                            (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'File'
                          ).LAN_NM, //파일
                    // value: props.imageFile.healthFiles || "",
                    onChange: (event) => {
                      const fileList = event.target.files;
                      if (Object.keys(fileList).length === 0) return;

                      const file = fileList[0]; // single file upload

                      const reader = new FileReader();
                      reader.readAsDataURL(file);
                      reader.onload = (e) => {
                        fetch(e.target.result)
                          .then((res) => res.blob())
                          .then((blob) => {
                            const image = new File(
                              [blob],
                              `${new Date()
                                .toISOString()
                                .replace(/T/, '')
                                .replace(/\..+/, '')
                                .replace(/-/g, '')
                                .replace(/:/g, '')}.png`,
                              {
                                type: 'image/png',
                              }
                            );

                            props.setImageFile({
                              ...props.imageFile,
                              healthFiles: reader.result,
                              healthImage: image,
                              healthFileName: file.name,
                            });
                          });
                      };
                      reader.onerror = (error) => {
                        console.log(error);
                        // 파일 읽기 중 에러가 발생했을 때 실행될 코드
                      };
                    },
                    buttonName:
                      props.lanInfo.length == 0
                        ? ''
                        : props.lanInfo.find(
                            (f) =>
                              f.LAN_TYPE == 'CALL' && f.LAN_ID === 'FileUpload'
                          ).LAN_NM, //파일 업로드
                  },
                ]}
              />

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  height: '90%',
                }}
              >
                {props.imageFile.healthFiles ? (
                  <img
                    id={'fileId'}
                    src={props.imageFile.healthFiles || ''}
                    style={{
                      maxWidth: '100%',
                      objectFit: 'contain',
                    }}
                  />
                ) : (
                  <Typography variant="h4">
                    등록된 보건카드가 없습니다.
                  </Typography>
                )}
              </Box>
            </div>
          }
        />
      )}
      {/* 서명 보기 팝업 창 */}
      {props.modalToggle2 && (
        <Dialog
          title={
            props.lanInfo.length == 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'SignatureName'
                ).LAN_NM
          } //서명
          titleSx={{ fontSize: '24px' }}
          open={props.modalToggle2}
          onClose={(e) => {
            props.setImageFile({
              ...props.imageFile,
              signFiles: '',
              signImage: '',
            });
            props.setModalToggle2(false);
          }}
          contentSx={{
            display: 'flex',
            flexDirection: 'column',
            height: '40vh',
          }}
          fullWidth
          saveButtonName={
            props.lanInfo.length == 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'Save'
                ).LAN_NM
          } //선택
          closeButtonName={
            props.lanInfo.length == 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'Close'
                ).LAN_NM
          } //닫기
          useSaveButton={false}
          useSaveAfterClose={true}
          onSave={{}}
          maxWidth="sm"
          btnSx={{ width: '120px', height: '60px' }}
          content={
            <div
              className="ag-theme-alpine no-scroll"
              style={{
                width: '100%',
                height: '100%',
                alignContent: 'center',
              }}
            >
              <MuiButton
                sx={{
                  minWidth: '50%',
                  borderRadius: '8px',
                  color: '#fff',
                  backgroundColor: '#2CA900',
                  fontSize: 20,
                  // '&:hover': {
                  //     backgroundColor:
                  //         , // 원하는 hover 배경색으로 설정
                  // },
                }}
                onClick={(e) => {
                  props.setModalToggle3(true);
                }}
              >
                <img
                  src={vector}
                  alt="icon"
                  style={{
                    marginRight: 8,
                  }}
                />
                {'서명하기'}
              </MuiButton>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  height: '90%',
                }}
              >
                <img
                  id={'fileId'}
                  src={props.imageFile.signFiles || ''}
                  style={{
                    maxWidth: '100%',
                    objectFit: 'contain',
                  }}
                />
              </Box>
            </div>
          }
        />
      )}
      {/* 서명 등록 팝업 창 */}
      {props.modalToggle3 && (
        <Dialog
          open={props.modalToggle3}
          titleSx={{ fontSize: 25 }}
          onClose={(e) => props.setModalToggle3(false)}
          contentSx={{
            display: 'flex',
            height: '40vh',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          title={'서명 등록'}
          content={
            <Canvas
              signatureCanvas={signatureCanvas}
              userId={props.inputs2.name}
            />
          }
          fullWidth
          saveButtonName={'저장'}
          closeButtonName={'닫기'}
          useSaveButton={true}
          useSaveAfterClose={false}
          maxWidth="md"
          onSave={(e) => {
            if (signatureCanvas.current) {
              const signatureDataUrl = signatureCanvas.current.toDataURL();
              props.setWorkSignature(signatureDataUrl);
              // handleOcr();
              const dataURL = signatureCanvas.current.toDataURL('image/png');

              // base64 데이터를 디코딩하여 Blob 생성
              const decodedData = atob(dataURL.split(',')[1]); // base64 부분만 분리하고 디코딩
              const byteNumbers = new Array(decodedData.length);

              // Uint8Array로 변환
              for (let i = 0; i < decodedData.length; i++) {
                byteNumbers[i] = decodedData.charCodeAt(i);
              }

              const byteArray = new Uint8Array(byteNumbers);

              const blob = new Blob([byteArray], {
                type: 'image/png',
              });
              const image = new File(
                [blob],
                `${new Date()
                  .toISOString()
                  .replace(/T/, '')
                  .replace(/\..+/, '')
                  .replace(/-/g, '')
                  .replace(/:/g, '')}.png`,
                {
                  type: 'image/png',
                }
              );
              if (!signatureCanvas.current._sigPad._isEmpty) {
                props.SaveLogic4(image);
                props.setModalToggle3(false);
              } else {
                props.setSnackbar({
                  ...props.snackbar,
                  open: true,
                  message: '서명을 진행하세요.',
                  type: Commons.TypeError().toLowerCase(),
                });
              }
            }
          }}
        />
      )}
      {/* 회원 탈퇴 팝업 창 */}
      {props.modalToggle4 && (
        <Dialog
          open={props.modalToggle4}
          titleSx={{ fontSize: 25 }}
          onClose={(e) => props.setModalToggle4(false)}
          contentSx={{
            display: 'flex',
          }}
          title={'탈퇴 안내'}
          btnSx={{
            width: '5vw',
            height: '4vh',
            fontSize: '2rem',
            marginRight: 2,
            marginBottom: 2,
          }}
          content={
            <Box sx={{ p: 2 }}>
              <Typography sx={{ fontSize: '1.7rem' }}>
                ㆍ회원탈퇴를 신청하기 전에 안내 사항을 꼭 확인해주세요.
              </Typography>
              <Typography
                sx={{
                  fontSize: '1.5rem',
                  mt: 2,
                  ml: 2,
                  fontWeight: 'bold',
                }}
              >
                <CheckIcon />
                사용하고 계신 아이디({props.userInfo.userid})는 탈퇴할 경우
                데이터 재사용 및 복구가 불가능합니다.
              </Typography>
              {/* <Box sx={{ ml: 2, mt: 2, display: "flex" }}>
								<Typography sx={{ fontSize: "1.5rem", color: "red" }}>
									탈퇴한 아이디는 본인과 타인 모두 재사용 및 복구가 불가
								</Typography>
								<Typography sx={{ fontSize: "1.5rem" }}>
									하오니 신중하게 선택하시기 바랍니다.
								</Typography>
							</Box> */}

              <Typography
                sx={{
                  fontSize: '1.5rem',
                  mt: 2,
                  ml: 2,
                  fontWeight: 'bold',
                }}
              >
                <CheckIcon />
                탈퇴 후 회원정보 및 개인형 서비스 이용기록은 모두 삭제됩니다.
              </Typography>
              <Typography
                sx={{
                  fontSize: '1.7rem',
                  mt: 2,
                  mb: 5,
                  color: 'red',
                }}
              >
                ㆍ탈퇴 후에는 아이디 {props.userInfo.userid} 로 다시 가입할 수
                없으며 아이디와 데이터는 복구할 수 없습니다.
                <br />
                ㆍ게시판형 서비스에 남아 있는 게시글은 탈퇴 후 삭제할 수
                없습니다.
              </Typography>
              <Checkbox
                name={'안내 사항을 모두 확인하였으며, 이에 동의합니다.'}
                checked={props.idDelete}
                onChange={(e) => props.setIdDelete(e)}
                nameSx={{ fontSize: '1.7rem' }}
              />
            </Box>
          }
          fullWidth
          saveButtonName={'확인'}
          closeButtonName={'닫기'}
          useSaveButton={true}
          useSaveAfterClose={false}
          maxWidth="md"
          onSave={(e) => {
            if (props.idDelete) {
              props.DeleteLogic1();
            } else {
              props.setSnackbar({
                ...props.snackbar,
                open: true,
                message: '탈퇴 안내를 확인하고 동의하세요.',
                type: Commons.TypeError().toLowerCase(),
              });
            }
          }}
        />
      )}
      {/* 직인 팝업 창 */}
      {props.modalToggle5 && (
        <Dialog
          title={
            props.lanInfo.length == 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'ImageSetup'
                ).LAN_NM
          } //사진 설정
          titleSx={{ fontSize: '24px' }}
          open={props.modalToggle5}
          onClose={(e) => {
            props.setImageFile({
              ...props.imageFile,
              journeyFiles: '',
              journeyImage: '',
            });
            props.setModalToggle5(false);
          }}
          contentSx={{
            display: 'flex',
            flexDirection: 'column',
            height: '40vh',
          }}
          fullWidth
          saveButtonName={
            props.lanInfo.length == 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'Save'
                ).LAN_NM
          } //선택
          closeButtonName={
            props.lanInfo.length == 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'Close'
                ).LAN_NM
          } //닫기
          useSaveButton={true}
          useSaveAfterClose={false}
          onSave={() => {
            props.SaveLogic5();
            if (props.imageFile.journeyImage) {
              props.setImageFile({
                ...props.imageFile,
                journeyFiles: '',
                journeyImage: '',
              });
              props.setModalToggle5(false);
            }
          }}
          maxWidth="sm"
          btnSx={{ width: '120px', height: '60px' }}
          content={
            <div
              className="ag-theme-alpine no-scroll"
              style={{
                width: '100%',
                height: '100%',
                alignContent: 'center',
              }}
            >
              <Button
                sx={{
                  fontSize: '14px',
                  height: '38px',
                  borderRadius: '4px',
                  mb: 1,
                }}
                size="medium"
                name={'직인 예시 보기'}
                onClick={() => {
                  props.setModalToggle6(true);
                }}
              />
              <FileForm
                datas={[
                  {
                    type: 'file',
                    sx: { fontSize: 14 },
                    name:
                      props.lanInfo.length == 0
                        ? ''
                        : props.lanInfo.find(
                            (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'File'
                          ).LAN_NM, //파일
                    // value: props.imageFile.journeyFiles || "",
                    onChange: (event) => {
                      const fileList = event.target.files;
                      if (Object.keys(fileList).length === 0) return;

                      const file = fileList[0]; // single file upload

                      const reader = new FileReader();
                      reader.readAsDataURL(file);
                      reader.onload = (e) => {
                        fetch(e.target.result)
                          .then((res) => res.blob())
                          .then((blob) => {
                            const canvas = document.createElement('canvas');
                            const ctx = canvas.getContext('2d');

                            const img = new Image();
                            img.crossOrigin = 'Anonymous'; // CORS 문제 방지
                            img.src = reader.result; // 원본 이미지

                            img.onload = function () {
                              canvas.width = img.width;
                              canvas.height = img.height;
                              ctx.drawImage(img, 0, 0);

                              const imageData = ctx.getImageData(
                                0,
                                0,
                                canvas.width,
                                canvas.height
                              );
                              const data = imageData.data;

                              // 특정 색(흰색) 제거: RGB(255,255,255)에 가까운 색을 투명화
                              for (let i = 0; i < data.length; i += 4) {
                                const r = data[i]; // Red
                                const g = data[i + 1]; // Green
                                const b = data[i + 2]; // Blue
                                const a = data[i + 3]; // Alpha (투명도)

                                // 흰색(또는 거의 흰색)이라면 투명하게 변경
                                if (r > 200 && g > 200 && b > 200) {
                                  data[i + 3] = 0; // 완전 투명하게 설정
                                }
                              }

                              ctx.putImageData(imageData, 0, 0);

                              // Data URL 형태로 PNG 이미지로 변환
                              const transparentImage =
                                canvas.toDataURL('image/png'); // 투명한 배경의 PNG 출력

                              // Data URL을 Blob으로 변환
                              fetch(transparentImage)
                                .then((res) => res.blob()) // Blob으로 변환
                                .then((blob) => {
                                  // Blob을 File 객체로 변환하여 저장
                                  const image = new File(
                                    [blob],
                                    `${new Date()
                                      .toISOString()
                                      .replace(/T/, '')
                                      .replace(/\..+/, '')
                                      .replace(/-/g, '')
                                      .replace(/:/g, '')}.png`,
                                    {
                                      type: 'image/png',
                                    }
                                  );

                                  props.setImageFile({
                                    ...props.imageFile,
                                    journeyFiles: transparentImage,
                                    journeyImage: image, // image 객체는 File 형태
                                    journeyFileName: file.name,
                                  });
                                })
                                .catch((err) => {
                                  console.error(
                                    'Error while converting image to Blob:',
                                    err
                                  );
                                });
                            };
                          });
                      };
                      reader.onerror = (error) => {
                        console.log(error);
                        // 파일 읽기 중 에러가 발생했을 때 실행될 코드
                      };
                    },
                    buttonName:
                      props.lanInfo.length == 0
                        ? ''
                        : props.lanInfo.find(
                            (f) =>
                              f.LAN_TYPE == 'CALL' && f.LAN_ID === 'FileUpload'
                          ).LAN_NM, //파일 업로드
                  },
                ]}
              />

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  height: '90%',
                }}
              >
                {props.imageFile.journeyFiles ? (
                  <img
                    id={'fileId'}
                    src={props.imageFile.journeyFiles || ''}
                    style={{
                      maxWidth: '100%',
                      objectFit: 'contain',
                    }}
                  />
                ) : (
                  <Typography variant="h4">등록된 직인이 없습니다.</Typography>
                )}
              </Box>
            </div>
          }
        />
      )}
      {/* 직인 예시 팝업 창 */}
      {props.modalToggle6 && (
        <Dialog
          title={'직인 예시'}
          titleSx={{ fontSize: '24px' }}
          open={props.modalToggle5}
          onClose={(e) => {
            props.setImageFile({
              ...props.imageFile,
              journeyFiles: '',
              journeyImage: '',
            });
            props.setModalToggle5(false);
          }}
          contentSx={{
            display: 'flex',
            flexDirection: 'column',
            height: '20vh',
          }}
          fullWidth
          useSaveButton={true}
          useCloseButton={false}
          saveButtonName={'확인'}
          closeButtonName={''}
          useSaveAfterClose={false}
          onSave={() => {
            props.setModalToggle6(false);
          }}
          maxWidth="sm"
          btnSx={{ width: '120px', height: '60px' }}
          content={
            <Box
              className="ag-theme-alpine no-scroll"
              style={{
                width: '100%',
                height: '100%',
                alignContent: 'center',
              }}
            >
              <Typography sx={{ fontSize: '14px', mb: 2 }}>
                직인의 배경은 흰색 또는 투명해야 합니다.
              </Typography>
              <Stack
                direction="row"
                spacing={8}
                sx={{
                  display: 'flext',
                  justifyContent: 'center',
                  alignContent: 'center',
                }}
              >
                <img
                  src={safeonJourneyman1}
                  style={{
                    maxWidth: '25%',
                    objectFit: 'contain',
                  }}
                />
                <img
                  src={safeonJourneyman2}
                  style={{
                    maxWidth: '25%',
                    objectFit: 'contain',
                  }}
                />
              </Stack>
            </Box>
          }
        />
      )}
    </Box>
  );
}

export default MyPage;
